import { render, staticRenderFns } from "./TelpIntvUserCard.vue?vue&type=template&id=099b6ecd&"
import script from "./TelpIntvUserCard.vue?vue&type=script&lang=js&"
export * from "./TelpIntvUserCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports